import {memo, ReactNode} from 'react';
import styles from './PageContainer.module.scss';

export const PageContainer = memo(({children, zigzag = true}: {children: ReactNode; zigzag?: boolean}) => {
  return <div className={`${styles.containerRevised} ${zigzag ? styles['zigzag-background'] : ''}`}>{children}</div>;
});
PageContainer.displayName = 'PageContainer';
